import { getUserToken } from "@/utils/getUserToken";
import { createStore } from "vuex";

export default createStore({
  state: {
    userDetails: getUserToken(),
    sidebarState: true,
  },
  getters: {
    getUserDetails(state) {
      return state.userDetails;
    },
  },
  mutations: {
    setUserInfo(state, payload) {
      state.userDetails = payload;
    },

    openSidebar(state) {
      state.sidebarState = true;
    },
    closeSidebar(state) {
      state.sidebarState = false;
    },
    // changeSidebarState(state) {
    //   state.sidebarState = !state.sidebarState;
    // },
  },
  actions: {
    openSidebar({ commit }) {
      commit("openSidebar");
    },

    closeSidebar({ commit }) {
      commit("closeSidebar");
    },
    // changeSidebarState({ commit }) {

    //   commit("changeSidebarState");
    // },
  },
  modules: {},
});
